import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMemberNameByUserId, getStringFromArray } from '../../utils';

class ShortContentLess extends Component {
  getShortContent() {
    const { block, members } = this.props;

    let content = '';
    let content1 = '';
    let contents = [];

    switch (block.name) {
      case 'Contribution':
        return { content: block.content };

      case 'Credit':
        contents = [
          'A credit to this contributor is not mandatory, but may be given at owner’s discretion.',
          'A credit will be provided to this contributor only if others in similar roles are given credit too.',
          'A credit will be provided to this Contributor.',
        ];

        return { content: contents[block.options.field1] };
      case 'Licensing Permissions':
        return '';
      case 'Governing Law':
        content =
          'The terms of this agreement will be governed by the laws of [STATE].';
        if (block.options.field1 === 'extra_region') {
          return { content: content.replace('[STATE]', '') };
        }
        return { content: content.replace('[STATE]', block.options.field1) };
      case 'Name & Likeness':
        contents = [
          'Collaborators need written permission each time before using the name and likeness another collaborator except when providing a credit.',
          'Collaborators can use the name and likeness of another collaborator without having to get written permission each time, as long as it’s used in a way that relates to the sale, license, or promotion of the work(s).',
        ];
        return { content: contents[block.options.field1] };
      case 'Indemnification':
        contents = [
          'Each collaborator will indemnify the others.',
          '[MEMBER] will indemnify the other collaborators.',
          'Intentionally omitted.',
        ];
        if (block.options.field1 === 1) {
          return {
            content: contents[1].replace(
              '[MEMBER]',
              getMemberNameByUserId(parseInt(block.options.field2, 10), members)
            ),
          };
        }
        return { content: contents[block.options.field1] };
      case 'Dispute Resolution':
        contents = [
          'The parties will undergo professional mediation.',
          'The parties will undergo binding arbitration.',
          'The parties will submit the dispute to a court of law in the region we have chosen.',
        ];

        let str = '';
        if (block.options.field1 === true) {
          str = contents[0];
        }
        if (block.options.field2 === true) {
          if (block.options.field1 === true) {
            str += ` ${contents[1]}`;
          } else {
            str = contents[1];
          }
        }
        if (block.options.field3 === true) {
          if (block.options.field1 === true) {
            str += ` ${contents[2]}`;
          } else {
            str = contents[2];
          }
        }
        return { content: str };
      case 'Cure; Remedies':
        contents = [
          'There is a window of [DAYS] days for the breaching party to fix the problem.',
          'A notice and cure period is not required before rights under this agreement can be enforced.',
        ];
        if (block.options.field1 === 0) {
          content = contents[0].replace('[DAYS]', block.options.field3);
        } else {
          content = contents[1];
        }
        if (block.options.field2 === 0) {
          content1 = 'Only monetary damages can be pursued.';
        } else if (block.options.field2 === 1) {
          content1 =
            'The parties can seek injunctive relief in addition to other remedies, such as monetary damages.';
        }
        return { content, content1 };

      case 'Consideration':
        let payment = '';

        if (block.options.schedule === 0) {
          payment =
            'The Contributor will be paid in full, within <DAYS0> days following full execution of this agreement';

          if (parseInt(block.options.scheduleDays0, 10) > 0) {
            payment = payment.replace(
              '<DAYS0>',
              parseInt(block.options.scheduleDays0, 10)
            );
          }
        } else if (block.options.schedule === 1) {
          payment =
            'The Contributor will be paid in full, within <DAYS1> days following the completion and delivery of the services.';

          if (parseInt(block.options.scheduleDays1, 10) > 0) {
            payment = payment.replace(
              '<DAYS1>',
              parseInt(block.options.scheduleDays1, 10)
            );
          }
        } else if (block.options.schedule === 2) {
          payment =
            'The Contributor will be paid as follows: $<AMOUNT> payable within <AMOUNTDAYS> days following full execution of this agreement, ' +
            'and the balance $<BALANCE> payable within <BALANCEDAYS> days following the completion and delivery of the services.';

          if (parseFloat(block.options.scheduleAmount) > 0) {
            payment = payment.replace(
              '<AMOUNT>',
              parseFloat(block.options.scheduleAmount).toFixed(2)
            );
          }
          if (parseInt(block.options.scheduleAmountDays, 10) > 0) {
            payment = payment.replace(
              '<AMOUNTDAYS>',
              parseInt(block.options.scheduleAmountDays, 10)
            );
          }
          if (parseFloat(block.options.scheduleBalance) > 0) {
            payment = payment.replace(
              '<BALANCE>',
              parseFloat(block.options.scheduleBalance).toFixed(2)
            );
          }
          if (parseInt(block.options.scheduleBalanceDays, 10) > 0) {
            payment = payment.replace(
              '<BALANCEDAYS>',
              parseInt(block.options.scheduleBalanceDays, 10)
            );
          }
        }

        if (block.options.payable === true) {
          content = 'The Contributor will be paid $<FEE>.<SPACE>';
        }

        if (block.options.royalty === true) {
          content +=
            'The Contributor will be paid a royalty. The Owner will account to the Contributor and pay royalties <PERIOD>.<SPACE>';
          content +=
            'The Contributor <WILL/WILL NOT> have a right to audit/examine the Owner’s books and records.<SPACE>';
        }

        if (block.options.gratis === true) {
          content =
            'The Contributor is not receiving monetary compensation, but getting other, promotional or marketing value from their contribution.<SPACE>';
        }

        if (parseFloat(block.options.fee) > 0) {
          content = content.replace(
            '<FEE>',
            parseFloat(block.options.fee).toFixed(2)
          );
        }
        if (parseInt(block.options.percent, 10) > 0) {
          content = content.replace(
            '<PERCENT>',
            parseInt(block.options.percent, 10)
          );
        }
        if (block.options.describe) {
          content = content.replace('<DESCRIBE>', block.options.describe);
        }
        if (block.options.period) {
          content = content.replace('<PERIOD>', block.options.period);
        }
        content = content.replace('<WILL/WILL NOT>', block.options.audit);
        content += payment;
        content = content.replace(new RegExp('<SPACE>', 'g'), ' ');
        return { content };

      case 'Services':
        content = getMemberNameByUserId(
          parseInt(block.options.producer, 10),
          members
        );
        content1 = block.content;
        return { content, content1 };
      case 'Ownership':
        if (block.options.composition === 0) {
          content =
            'Producer does not have a claim of ownership or authorship on the musical composition(s). ';
        } else if (block.options.composition === 1) {
          content =
            'Producer does have a claim of ownership or authorship on the musical composition(s). ';
        }
        if (block.options.consent === 0) {
          content1 =
            'Producer cannot distribute, display, reproduce, or otherwise use the recording(s) without written permission.';
        } else if (block.options.consent === 1) {
          content1 =
            'Producer can distribute, display, reproduce, or otherwise use the recording(s) without written permission.';
        }
        return { content, content1 };
      case 'Payments':
        if (block.options.paidType === 0) {
          content =
            `The Producer will be paid a fee and will not receive a royalty.` +
            `<br />The Producer will be paid a rate of $${(
              block.options.amount || ''
            )
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${
              block.options.feeType === 'perHour' ? 'per hour' : 'in total'
            }.`;
        } else if (block.options.paidType === 1) {
          content =
            `The Producer will be paid a fee and will receive a royalty of net receipts. ` +
            `<br />The Producer will be paid a rate of $${(
              block.options.amount || ''
            )
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${
              block.options.feeType === 'perHour' ? 'per hour' : 'in total'
            }.`;
        } else if (block.options.paidType === 2) {
          content =
            `The Producer will be paid an advance of their royalty from net receipts.` +
            `<br />The advance will be of $${(block.options.amount || '')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.`;
        }
        if (block.options.paySchedule === 0) {
          if (block.options.scheduleType === 'execution') {
            content += ` The Producer will be paid ${block.options.day} days following the execution of this agreement.`;
          } else if (block.options.scheduleType === 'completion') {
            content += ` The Producer will be paid ${block.options.day} days following the completion and delivery of the services.`;
          }
        } else if (block.options.paySchedule === 1) {
          content += ` The Producer will be paid $${block.options.amount1
            .toString()
            .replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ','
            )} following full execution of this agreement and the balance $${block.options.amount2
            .toString()
            .replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ','
            )} following the completion and delivery of the services.`;
        }
        if (block.options.paidType === 1 || block.options.paidType === 2) {
          content += ` The Producer will be paid a royalty of ${
            block.options.percentage
          }% of Owner’s Net Receipts from all ${getStringFromArray(
            'payments',
            block.options
          )}.`;
          content += ` Royalties will be paid and accounted to the Producer over a ${block.options.period} period within ${block.options.periodDay} days of the end of that period.`;
          content += ` The Producer ${
            block.options.auditType === 'will' ? 'will' : 'will not'
          } have the right to conduct an audit.`;
        }
        if (block.options.statutoryPercentage !== '') {
          content += ` The Producer will be paid ${block.options.statutoryPercentage}% of the minimum statutory rate for copies sold/downloaded in the U.S.`;
        }
        return { content };
      case 'Credit; Name and Likeness':
        content = `Producer will receive a credit of ${block.options.creditTitle}.`;
        return { content };
      default:
        return { content: '' };
    }
  }

  render() {
    const { block, agreement, tabName } = this.props;

    if (
      (agreement.type === 'premium' &&
        block['block_type'].includes('premium') === true) ||
      (agreement.type === 'workforhire' &&
        block['block_type'].includes('work_for_hire') === true) ||
      (agreement.type === 'producer' &&
        block['block_type'].includes('producer') === true)
    ) {
      let { content, content1 } = this.getShortContent();

      if (
        block.name === 'Services' ||
        block.name === 'Ownership' ||
        block.name === 'Cure; Remedies'
      ) {
        return (
          <div className={`${tabName === block.name && 'block-selected'}`}>
            <div className="contract-block">
              <div>
                <label>{block.name}</label>
              </div>
              <div>
                {block.name === 'Ownership' && (
                  <div>
                    The Producer will not own the master(s). <br />
                  </div>
                )}
                <p>
                  {block.name === 'Services' ? (
                    content === '' ? (
                      <span className="member-placeholder">
                        Select Member is the producer and will provide
                      </span>
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: `${content} is the producer and will provide`,
                        }}
                      ></span>
                    )
                  ) : (
                    <span dangerouslySetInnerHTML={{ __html: content }}></span>
                  )}
                  &nbsp;
                </p>
                {this.props.children}
                <p>
                  <span dangerouslySetInnerHTML={{ __html: content1 }}></span>
                  &nbsp;
                </p>
                {this.props.children1}
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className={`${tabName === block.name && 'block-selected'}`}>
            <div className="contract-block">
              <div>
                <label>{block.name}</label>
              </div>
              <div>
                <p>
                  <span dangerouslySetInnerHTML={{ __html: content }}></span>
                  &nbsp;
                </p>
                {this.props.children}
              </div>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  agreement: state.agreements.selectedAgreement,
  members: state.users.members,
});

export default connect(mapStateToProps)(ShortContentLess);



// WEBPACK FOOTER //
// src/components/DealContractBlock/ShortContentLess.jsx